"use client";

import Link from "next/link";
import { CloseIcon, PanelIcon } from "@/components/icons";
import { ToolRequestBell } from "@/components/ToolRequests";
import { APP_HOME } from "@/lib/appHome";

/** The wordmark, the tool-request bell and the two ways to put the sidebar away. */
export function SidebarHeader({
  onHide,
  onCloseDrawer,
}: {
  /** Collapse the desktop column. */
  onHide: () => void;
  /** Dismiss the mobile drawer. */
  onCloseDrawer: () => void;
}) {
  return (
    <div data-sidebar-header className="flex shrink-0 items-center gap-2 px-4 py-4 md:h-[var(--page-header-height,4.5rem)] md:py-3">
      <Link href={APP_HOME} onClick={onCloseDrawer} className="flex min-w-0 flex-1 items-center gap-2.5">
        <span className="flex size-8 shrink-0 items-center justify-center rounded-lg bg-violet-600 text-base font-bold text-white">
          W
        </span>
        <span className="truncate text-base font-semibold tracking-tight text-zinc-100">
          Create a Worker
        </span>
      </Link>
      <ToolRequestBell />
      <button
        type="button"
        onClick={onHide}
        title="Hide sidebar"
        aria-label="Hide sidebar"
        className="hidden shrink-0 rounded-md p-1.5 text-zinc-500 transition hover:bg-zinc-800 hover:text-zinc-200 md:inline-flex"
      >
        <PanelIcon className="size-4" />
      </button>
      <button
        type="button"
        onClick={onCloseDrawer}
        title="Close menu"
        aria-label="Close menu"
        className="flex size-8 items-center justify-center rounded-lg text-zinc-400 transition hover:bg-zinc-800 hover:text-zinc-100 md:hidden"
      >
        <CloseIcon className="size-5" />
      </button>
    </div>
  );
}
